import React from 'react'

import "./Gallery.css";

const Doctors_Gallery = () => {
    return (
        <>
            <div className="container-fluid strips " id="strip" style={{ display: 'flex', backgroundColor: "#0899ff" }}>
                <div className="col text-center strip1" style={{ color: 'white' }}>
                    <div className="row mt-5 mb-5" >
                        <h1 style={{ textTransform: 'uppercase' }}>GALLERY</h1>
                    </div>
                </div>
            </div>
            <div className="custom-container mt-3">
                <div className='row'>
                    <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./1.jpeg' alt=''></img>
                        </div>
                    </div>
                    <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./2.jpeg' alt=''></img>
                        </div>
                    </div>
                    <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./3.jpeg' alt=''></img>
                        </div>
                    </div>
                    <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./4.jpeg' alt=''></img>
                        </div>
                    </div>
                    <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./5.jpeg' alt=''></img>
                        </div>
                    </div>
                    <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./6.jpeg' alt=''></img>
                        </div>
                    </div>
                     <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./7.jpeg' alt=''></img>
                        </div>
                    </div>
                     <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./8.jpeg' alt=''></img>
                        </div>
                    </div>
                     <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./9.jpeg' alt=''></img>
                        </div>
                    </div>
                     <div className='col-md-3  col-sm-6 mb-4'>
                        <div className='card card_image'>
                            <img src='./10.jpeg' alt=''></img>
                        </div>
                    </div>
                    
                </div>
            </div>
        </>
    )
}

export default Doctors_Gallery